import { render, staticRenderFns } from "./AsCoachInspectChecklistCard.vue?vue&type=template&id=6961d4b8&scoped=true"
import script from "./AsCoachInspectChecklistCard.vue?vue&type=script&setup=true&lang=js"
export * from "./AsCoachInspectChecklistCard.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AsCoachInspectChecklistCard.vue?vue&type=style&index=0&id=6961d4b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6961d4b8",
  null
  
)

export default component.exports